import type { BuildupOptions, ComponentConfigV2 } from '@/types/configurationV2'

export default function BuildupOptionsEditor({
  component,
  onUpdate,
}: { component: ComponentConfigV2; onUpdate: (u: ComponentConfigV2) => void }) {
  const options = component.options as BuildupOptions
  const audioResponse = options.audioResponse ?? { enabled: true, required: false }
  const update = (next: BuildupOptions['audioResponse']) =>
    onUpdate({ ...component, options: { ...options, audioResponse: next } })

  return (
    <div className="space-y-3">
      <p className="text-xs text-gray-500">
        빌드업 본문과 교사 채점 항목은 깨처 콘텐츠의 <code>buildup</code> 데이터에서 자동 결정됩니다.
      </p>
      <label className="flex items-center gap-1.5 text-xs">
        <input
          type="checkbox"
          checked={audioResponse.required}
          onChange={(event) => update({ ...audioResponse, required: event.target.checked })}
        />
        자동완료 시 음성 응답 필수
      </label>
    </div>
  )
}
